export enum DayOfTheWeek {
  Sunday = 'Sunday',
  Monday = 'Monday',
  Tuesday = 'Tuesday',
  Wednesday = 'Wednesday',
  Thursday = 'Thursday',
  Friday = 'Friday',
  Saturday = 'Saturday',
}

export const AllDaysOfTheWeek: DayOfTheWeek[] = [
  DayOfTheWeek.Sunday,
  DayOfTheWeek.Monday,
  DayOfTheWeek.Tuesday,
  DayOfTheWeek.Wednesday,
  DayOfTheWeek.Thursday,
  DayOfTheWeek.Friday,
  DayOfTheWeek.Saturday,
];

export const getDayAbbreviation = (day: DayOfTheWeek): string => {
  return day.substring(0, 3);
};
